import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
	selector: 'app-add-image-error',
	templateUrl: './add-image-error.component.html',
	styleUrls: ['./add-image-error.component.scss']
})
export class AddImageErrorComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<AddImageErrorComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData:any)
	{

	}

	ngOnInit(): void {
		// Ng On Init
	}

	// ERROR TRY AGAIN.
	onClickTryAgain = () => {
		this.dialogRef.close(this.dailogData);
	}
}